import { render, staticRenderFns } from "./AllocationModal.vue?vue&type=template&id=18624b06&scoped=true&"
import script from "./AllocationModal.vue?vue&type=script&lang=js&"
export * from "./AllocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18624b06",
  null
  
)

export default component.exports